import { useEffect } from "react";
import Supply from '../table/Tablesupplychain';
import Modal from "../modal/Modaladdsupply"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Supply/>
    
     
     </>
  );
};

export default Dashboard;
